// Keep the candle gallery, scent picker and purchase forms in sync.
(() => {
  if (window.keepInTouchCandlePhotoSync) return;
  window.keepInTouchCandlePhotoSync = true;
  const aliases = {
    '35951921299737': '50009768132889',
    '35952501391641': '46821603246361',
    '36958787272985': '47397009195289',
    '36958810243353': '50009768132889',
    '38954489839897': '46821603082521'
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button');
    const thumbnail = button && button.closest('[data-target]');
    const section = thumbnail && thumbnail.closest('[id^="MainProduct-"]');
    if (!section || section.dataset.candlePhotoSync !== 'true') return;
    if (!thumbnail.closest('[id^="GalleryThumbnails-"]')) return;
    const picker = section.querySelector('variant-selects, variant-radios');
    if (!picker || typeof picker.getVariantData !== 'function') return;
    const mediaId = thumbnail.dataset.target.split('-').pop();
    const variants = picker.getVariantData();
    const variant = aliases[mediaId]
      ? variants.find((item) => String(item.id) === aliases[mediaId])
      : variants.find((item) => item.featured_media && String(item.featured_media.id) === mediaId);
    if (!variant) return;
    const selects = Array.from(picker.querySelectorAll('select'));
    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
    if (selects.length === variant.options.length) {
      selects.forEach((select, index) => { select.value = variant.options[index]; });
    } else if (fieldsets.length === variant.options.length) {
      const inputs = fieldsets.map((fieldset, index) =>
        Array.from(fieldset.querySelectorAll('input')).find((input) => input.value === variant.options[index]));
      if (inputs.some((input) => !input)) return;
      inputs.forEach((input) => { input.checked = true; });
    } else {
      return;
    }
    // Use the theme's native flow, including availability, price and cart variant.
    picker.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
